// Vendor
import { model } from '@angular/core';
import { finalize } from 'rxjs/operators';
// Services
import { NotificationsService } from 'NotificationsApp/ts/services/notifications.service';
import * as i0 from "@angular/core";
import * as i1 from "NotificationsApp/ts/services/notifications.service";
import * as i2 from "@angular/common";
import * as i3 from "NotificationsApp/ts/features/notifications-side-menu/components/notifications-menu-list-item/notifications-menu-list-item.component";
const _c0 = () => ({ "flex": "0 0 65%" });
const _c1 = a0 => ({ active: a0 });
const _c2 = () => [];
function NotificationsSideMenuComponent_table_16_tr_2_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 16);
    i0.ɵɵlistener("removeNotification", function NotificationsSideMenuComponent_table_16_tr_2_Template_tr_removeNotification_0_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.removeNotification($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const notification_r3 = ctx.$implicit;
    i0.ɵɵproperty("notification", notification_r3);
} }
function NotificationsSideMenuComponent_table_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "table", 14)(1, "tbody");
    i0.ɵɵtemplate(2, NotificationsSideMenuComponent_table_16_tr_2_Template, 1, 1, "tr", 15);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.notificationsByCategory[ctx_r1.activeTab]);
} }
function NotificationsSideMenuComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtext(1, "No new notifications.");
    i0.ɵɵelementEnd();
} }
export class NotificationsSideMenuComponent {
    constructor(notificationsService) {
        this.notificationsService = notificationsService;
        this.loading = false;
        this.notifications = model([], ...(ngDevMode ? [{ debugName: "notifications" }] : []));
        this.notificationsByCategory = {};
        this.activeTab = 'activity';
    }
    ngOnInit() {
        this.setNotificationsByCategory();
    }
    deleteAllNotifications() {
        this.loading = true;
        this.notificationsService
            .deleteNotifications()
            .pipe(finalize(() => {
            this.loading = false;
        }))
            .subscribe({
            next: () => {
                this.notifications.set([]);
                this.setNotificationsByCategory();
            },
            error: () => { },
        });
    }
    removeNotification(notification) {
        this.notifications.set(this.notifications().filter((n) => n.id !== notification.id));
        this.setNotificationsByCategory();
    }
    selectTab(tabType) {
        this.activeTab = tabType;
    }
    setNotificationsByCategory() {
        // TODO: Update this mapping once notifications have a notification type
        this.notificationsByCategory = {
            activity: this.notifications(),
            todo: [],
        };
    }
}
NotificationsSideMenuComponent.ɵfac = function NotificationsSideMenuComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || NotificationsSideMenuComponent)(i0.ɵɵdirectiveInject(i1.NotificationsService)); };
NotificationsSideMenuComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NotificationsSideMenuComponent, selectors: [["ycn-notifications-side-menu"]], inputs: { notifications: [1, "notifications"] }, outputs: { notifications: "notificationsChange" }, standalone: false, decls: 18, vars: 12, consts: [[1, "regions"], [1, "region", "region-top", 3, "ngStyle"], [1, "region-header"], [1, "region-tabs"], ["data-test-id", "todo-tab", 1, "region-tab-link", 3, "click", "ngClass"], [1, "bullet", "bullet-2"], ["data-test-id", "activity-tab", 1, "region-tab-link", 3, "click", "ngClass"], [1, "bullet", "bullet-15"], [1, "region-body", "ng-scope"], [1, "overflow-shadow-y", "height-full", "scrolled-top"], [1, "overflow-shadow-inner", "height-full"], [1, "notifications-body", "panel-content"], ["data-test-id", "notifications-table", "class", "table table-airy table-hover mb-1 ng-scope", 4, "ngIf"], ["data-test-id", "notifications-empty-state", "class", "notifications-empty ng-scope", 4, "ngIf"], ["data-test-id", "notifications-table", 1, "table", "table-airy", "table-hover", "mb-1", "ng-scope"], ["ycn-notifications-menu-list-item", "", 3, "notification", "removeNotification", 4, "ngFor", "ngForOf"], ["ycn-notifications-menu-list-item", "", 3, "removeNotification", "notification"], ["data-test-id", "notifications-empty-state", 1, "notifications-empty", "ng-scope"]], template: function NotificationsSideMenuComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "div", 4);
        i0.ɵɵlistener("click", function NotificationsSideMenuComponent_Template_div_click_4_listener() { return ctx.selectTab("todo"); });
        i0.ɵɵelement(5, "div", 5);
        i0.ɵɵelementStart(6, "span");
        i0.ɵɵtext(7, "To Do");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(8, "div", 6);
        i0.ɵɵlistener("click", function NotificationsSideMenuComponent_Template_div_click_8_listener() { return ctx.selectTab("activity"); });
        i0.ɵɵelement(9, "div", 7);
        i0.ɵɵelementStart(10, "span");
        i0.ɵɵtext(11, "Activity");
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(12, "div", 8)(13, "div", 9)(14, "div", 10)(15, "div", 11);
        i0.ɵɵtemplate(16, NotificationsSideMenuComponent_table_16_Template, 3, 1, "table", 12)(17, NotificationsSideMenuComponent_div_17_Template, 2, 0, "div", 13);
        i0.ɵɵelementEnd()()()()()();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction0(5, _c0));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c1, ctx.activeTab == "todo"));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c1, ctx.activeTab == "activity"));
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("ngIf", (ctx.notificationsByCategory[ctx.activeTab] ?? i0.ɵɵpureFunction0(10, _c2)).length);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !(ctx.notificationsByCategory[ctx.activeTab] ?? i0.ɵɵpureFunction0(11, _c2)).length);
    } }, dependencies: [i2.NgClass, i2.NgForOf, i2.NgIf, i2.NgStyle, i3.NotificationsMenuListItemComponent], encapsulation: 2 });
